<template>
  <el-container style="height: 100%">
    <el-header style="padding: 10px 40px; height: auto">
      <div style="float: left">
        <img v-if="imgshow" src="static/logo-xg.png" style="margin-top: 6px" width="250" alt="" />
        <img v-if="!imgshow" src="static/logo-en-xg.png" style="margin-top: 6px" alt="" />
      </div>
      <div style="float: right">
        <el-popover placement="top-start" trigger="click">
          <div style="text-align: center">
            <div>
              <el-button @click="account()" type="text">{{ $t('home.激活设备') }}</el-button>
            </div>
            <div>
              <el-button @click="changepwd()" type="text">{{ $t('home.修改密码') }}</el-button>
            </div>
            <div>
              <el-button @click="logout" type="text">{{ $t('home.退出登录') }}</el-button>
            </div>
          </div>
          <div style="color: white; margin-top: 20px; cursor: pointer" slot="reference">
            <i class="el-icon-service"></i>
            <span style="margin: 0 4px">{{ username }}</span>
            <i class="el-icon-arrow-down"></i>
          </div>
        </el-popover>
      </div>
    </el-header>
    <el-container>
      <el-aside width="300px">
        <div style="padding: 15px">
          <div style="background: white; margin-top: 10px">
            <div class="sort-option">
              <label for="">{{ $t('home.排序方式') }}</label>
              <el-select :no-data-text="$t('home.noData')" v-model="selectSortValue" @change="selectSortChange" style="width: 150px">
                <el-option value="equipmentno" :label="$t('home.设备编码')"></el-option>
                <el-option value="equipmentnm" :label="$t('home.设备名称')"></el-option>
              </el-select>
            </div>
            <el-tabs v-model="activeName2" type="border-card" @tab-click="handleClick">
              <el-tab-pane name="first">
                <span slot="label" style="font-weight: normal; font-size: 12px">{{ $t('home.我的设备') }}</span>
                <el-collapse>
                  <div>
                    <span style="font-size: 12px; color: #999; padding-right: 10px">{{ $t('home.检索设备') }}:</span>
                    <input type="text" v-model="equipmentnm" @input="filterItem" style="width: 60%; height: 28px; border: 1px solid #f1f1f1" />
                  </div>
                  <div class="item" v-if="true" style="cursor: pointer" @click="$router.push({ name: 'AllExcelData' })">
                    <div class="itemName" style="color: #000;white-space: nowrap;">{{ $t('home.数据批量导出') }}</div>
                    <div class="itemMap"></div>
                  </div>
                  <div class="item" v-if="true" style="cursor: pointer" @click="$router.push({ name: 'Report' })">
                    <div class="itemName" style="color: #000;white-space: nowrap;">{{ $t('home.设备报表') }}</div>
                    <div class="itemMap"></div>
                  </div>

                  <el-collapse-item v-for="(m, index) in groupArr" :key="index" :title="m.name" :name="m.name">
                    <div class="item" v-for="n in m.items" :key="n.equipid + '_' + n.id">
                      <div class="itemName">
                        <router-link
                          :to="{
                            name: 'Detail',
                            params: { dId: n.equipid },
                            query: {
                              myequips: true,
                              equipid: n.equipid,
                              equipmentnm: n.equipmentnm,
                              equipmentno: n.equipmentno,
                              standardjd: n.standardjd,
                              standardwd: n.standardwd,
                              offsize: n.offsize,
                              dataspan: n.dataspan
                            }
                          }"
                          class="alink"
                          active-class="alinkS"
                        >
                          {{ n.equipmentnm }}
                        </router-link>
                      </div>

                      <div class="itemMap">
                        <a v-if="showMon(n)" @click="goKanban(n)" style="cursor: pointer;margin-right: 10px;" class="alinkM">{{ $t('home.看板1') }}</a>
                        <router-link
                          :key="n.equipid + '_my'"
                          :to="{
                            name: 'Map',
                            params: {
                              mapName: n.equipmentnm,
                              mapId: n.equipid
                            }
                          }"
                          class="alinkM"
                        >
                          {{ $t('home.地图') }}
                        </router-link>
                        <a v-if="showPu(n)" @click="goBopu(n)" style="cursor: pointer" class="alinkM">{{ $t('home.波谱') }}</a>
                        <router-link
                          v-if="false"
                          :to="{
                            name: 'boputu',
                            params: {
                              Equipid: n.equipid,
                              Equipno: n.equipmentno
                            }
                          }"
                          class="alinkM"
                        >
                          {{ $t('home.波谱') }}
                        </router-link>
                        <router-link v-if="false" :to="{ name: 'VerticalMonitoring' }" class="alinkM">
                          {{ $t('home.广告机') }}
                        </router-link>
                      </div>
                    </div>
                  </el-collapse-item>
                </el-collapse>
              </el-tab-pane>
              <el-tab-pane name="second">
                <span slot="label" style="font-weight: normal; font-size: 12px">{{ $t('home.其它设备') }}</span>
                <div class="item" v-for="n in sharedequips" :key="n.equipid + '_' + n.id">
                  <div class="itemName">
                    <router-link
                      :to="{
                        name: 'Detail',
                        params: { dId: n.equipid },
                        query: {
                          equipmentnm: n.equipmentnm,
                          equipmentno: n.equipmentno
                        }
                      }"
                      class="alink"
                      active-class="alinkS"
                    >
                      {{ n.equipmentnm }}
                    </router-link>
                  </div>
                  <div class="itemMap">
                    <router-link :key="n.equipid + '_other'" :to="{ name: 'Map', params: { mapId: n.equipid } }" class="alinkM">地图</router-link>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </el-aside>

      <el-container>
        <el-main>
          <router-view @changeEquip="changeEquip()"></router-view>
        </el-main>
      </el-container>
    </el-container>
  </el-container>
</template>

<script>
import { mapMutations } from 'vuex'

import { myequips, sharedequips } from '../service/getData'
import { getToken, removeToken, getUser, removeUser } from '../utils/auth'

export default {
  data() {
    return {
      input23: '',
      activeName2: 'first',
      myequips: null,
      sharedequips: null,
      username: getUser(),
      groupArr: null,
      groupArr1: null,

      sourceGroupArr: null,
      equipmentnm: null,
      // 排序方式
      selectSortValue: 'equipmentnm',
      lang: '',
      imgshow: true
    }
  },
  methods: {
    ...mapMutations(['SET_DEVICE']),
    selectSortChange(v) {
      this.myequips_sharedequips(v)
    },
    showdfbkanb(n) {
      if (n.equiptypenm === '大浮标v1.0') {
        return true
      } else if (n.equiptypenm === '大浮标V2.0') {
        return true
      } else {
        return false
      }
    },

    handleClick() {},
    logout() {
      removeToken()
      removeUser()
      localStorage.removeItem('layer')
      this.$router.push('/login')
    },

    account() {
      this.$router.push('/home/account')
    },
    showMon(n) {
      let status = false
      switch (n.equiptypenm) {
        case '大浮标v1.0':
          status = true
          // Monitoring @/components/Monitoring
          break

        case '气象监测浮标':
          status = true
          // Monitoring @/components/Monitoring
          break

        case '大浮标V2.0':
          status = true
          // Monitoring @/components/Monitoring
          break
        case '水质监测浮标':
          status = true
          // Monitoring @/components/Monitoring
          break
        case 'Met Buoy':
          status = true
          // Monitoring @/components/Monitoring
          break
        default:
          status = false
          break
      }
      return status
    },
    showPu(n) {
      let status = false
      switch (n.equiptypenm) {
        case 'GNSS谱回传':
          status = true
          // Monitoring @/components/Monitoring
          break
        case '波浪浮标4G谱数据':
          status = true
          // Monitoring @/components/Monitoring
          break
        default:
          status = false
          break
      }
      return status
    },
    goKanban(n) {
      switch (n.equiptypenm) {
        case '大浮标v1.0':
          this.$router.push({
            name: 'Monitoring',
            query: { equipid: n.equipid }
          })
          // Monitoring @/components/Monitoring
          break

        case '气象监测浮标':
          this.$router.push({
            name: 'Monitoring77',
            query: { equipid: n.equipid }
          })
          // Monitoring @/components/Monitoring
          break

        case '大浮标V2.0':
          this.$router.push({
            name: 'Monitoring26',
            query: { equipid: n.equipid }
          })
          // Monitoring @/components/Monitoring
          break
        case '水质监测浮标':
          this.$router.push({
            name: 'Monitoring128',
            query: { equipid: n.equipid }
          })
          break
        case 'Met Buoy':
          this.$router.push({
            name: 'Monitoring5638',
            query: { equipid: n.equipid, Equipno: n.equipmentnm }
          })
          // Monitoring @/components/Monitoring
          break
        // Monitoring @/components/Monitoring
      }
    },
    goBopu(n) {
      console.log(n)
      switch (n.equiptypenm) {
        case 'GNSS谱回传':
          this.$router.push({
            name: 'boputu',
            params: {
              Equipid: n.equipid,
              Equipno: n.equipmentno
            }
          })
          // Monitoring @/components/Monitoring
          break
        case '波浪浮标4G谱数据':
          this.$router.push({
            name: 'newboputu',
            params: {
              Equipid: n.equipid,
              Equipno: n.equipmentno
            }
          })
          // Monitoring @/components/Monitoring
          break
      }
    },
    changepwd() {
      this.$router.push('/home/changepwd')
    },
    changeEquip() {
      this.myequips_sharedequips()
    },
    async myequips_sharedequips(v = 'equipmentnm') {
      let result = await myequips()
      let data = result.data
      this.sourceGroupArr = [...data]
      this.filterEquipmentnm(data, v)

      let result2 = await sharedequips()
      let data2 = result2.data
      if (v === 'equipmentno') {
        data2 = data2.sort((a, b) => {
          return +a[v] - +b[v]
        })
      } else {
        data2 = data2.sort((a, b) => a[v].localeCompare(b[v]))
      }
      this.sharedequips = data2
      console.log(this.sharedequips)
      localStorage.setItem('sharedequips', JSON.stringify(data2))
    },
    filterItem() {
      const arr = this.sourceGroupArr.filter(item => item.equipmentnm.includes(this.equipmentnm))
      this.filterEquipmentnm(arr)
    },
    filterEquipmentnm(data, v = 'equipmentnm') {
      let type = []
      data.map(n => {
        if (!type.includes(n.equiptypeid)) {
          type.push(n.equiptypeid)
        }
      })

      if (v === 'equipmentno') {
        data = data.sort((a, b) => {
          return +a[v] - +b[v]
        })
      } else {
        data = data.sort((a, b) => a[v].localeCompare(b[v]))
      }
      let groupArr = []
      for (let i = 0; i < type.length; i++) {
        data.map(n => {
          if (n.equiptypeid == type[i]) {
            if (!groupArr[i]) {
              groupArr[i] = {
                name: n.equiptypenm,
                items: []
              }
            }
            groupArr[i].items.push(n)
          }
        })
      }
      this.groupArr = groupArr
      console.log(this.groupArr)
    }
  },
  mounted() {
    if (!getToken()) {
      this.$router.push('/login')
      return
    } else {
      this.myequips_sharedequips()
    }
    this.lang = localStorage.getItem('lang') || 'zh'
    if (this.lang === 'zh') {
      this.imgshow = true
    } else {
      this.imgshow = false
    }
  }
}
</script>
<style lang="scss" scoped>
.sort-option {
  font-size: 12px;
  padding: 15px;

  & > label {
    margin-right: 20px;
  }
}

.el-header,
.el-footer {
  background-color: #b3c0d1;
  background-image: linear-gradient(-225deg, #205d86 0%, #106f9d 100%);
  color: #333;
}

.el-aside {
  /* Rectangle 7: */
  background: #e8e8e8;
  color: #333;
}

.el-main {
  background-color: #e9eef3;
  color: #333;
  height: calc(100vh - 75px);
}

body > .el-container {
  margin-bottom: 40px;
}

.el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
  line-height: 260px;
}

.el-container:nth-child(7) .el-aside {
  line-height: 320px;
}

.item {
  border-bottom: 1px solid #f1f1f1;
  padding: 15px 0;
  font-size: 12px;
  color: #999;

  .itemName {
    display: inline-block;
    width: 100px;
    text-align: left;
  }

  .itemMap {
    float: right;
    color: #4a90e2;
  }

  .itemKanb {
    display: inline-block;
    margin-left: 75px;
  }

  .kanbword {
    color: #f44;
  }
}

.scrollbar-wrapper {
  overflow-x: hidden !important;

  .el-scrollbar__view {
    height: 100%;
  }
}
</style>
<style>
.el-tabs--border-card > .el-tabs__content {
  padding: 15px;
  height: calc(100vh - 187px);
}

.el-tabs__content {
  overflow: auto;
  position: relative;
}
</style>
